var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubsBill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_228_1463)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_228_1463)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_1463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_1463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_1463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 18.03C18.25 18.57 18.4 18.65 18.74 18.77L19.25 18.95V17.25H18.95C18.57 17.25 18.25 17.6 18.25 18.03Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 22.7498H21.05C21.44 22.7498 21.75 22.3998 21.75 21.9698C21.75 21.4298 21.6 21.3498 21.26 21.2298L20.75 21.0498V22.7498Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.58 13.48L25.53 15.53C25.38 15.68 25.19 15.75 25 15.75C24.81 15.75 24.62 15.68 24.47 15.53C24.18 15.24 24.18 14.76 24.47 14.47L26.52 12.42C24.76 10.92 22.49 10 20 10C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30C25.52 30 30 25.52 30 20C30 17.51 29.08 15.24 27.58 13.48ZM21.75 19.82C22.39 20.05 23.25 20.51 23.25 21.98C23.25 23.23 22.26 24.26 21.05 24.26H20.75V24.51C20.75 24.92 20.41 25.26 20 25.26C19.59 25.26 19.25 24.92 19.25 24.51V24.26H19.17C17.84 24.26 16.75 23.14 16.75 21.76C16.75 21.34 17.09 21 17.5 21C17.91 21 18.25 21.34 18.25 21.75C18.25 22.3 18.66 22.75 19.17 22.75H19.25V20.53L18.25 20.18C17.61 19.95 16.75 19.49 16.75 18.02C16.75 16.77 17.74 15.74 18.95 15.74H19.25V15.5C19.25 15.09 19.59 14.75 20 14.75C20.41 14.75 20.75 15.09 20.75 15.5V15.75H20.83C22.16 15.75 23.25 16.87 23.25 18.25C23.25 18.66 22.91 19 22.5 19C22.09 19 21.75 18.66 21.75 18.25C21.75 17.7 21.34 17.25 20.83 17.25H20.75V19.47L21.75 19.82Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.69 9.71C30.61 9.53 30.47 9.38 30.28 9.3C30.19 9.27 30.1 9.25 30 9.25H26C25.59 9.25 25.25 9.59 25.25 10C25.25 10.41 25.59 10.75 26 10.75H28.19L26.52 12.42C26.9 12.75 27.25 13.1 27.58 13.48L29.25 11.81V14C29.25 14.41 29.59 14.75 30 14.75C30.41 14.75 30.75 14.41 30.75 14V10C30.75 9.9 30.73 9.81 30.69 9.71Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_1463",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_1463",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_1463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsBill);
export default __webpack_public_path__ + "static/media/subsBill.6af8bafb0b4b8265dfa498e2710f3f03.svg";
export { ForwardRef as ReactComponent };